import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

import { money as moneyFormat } from 'utils/format/money';
import { useManagerPolicyContext } from '../../../../contexts/ManagerPolicyContext';
import statuses from '../../../../data/policy_statuses';

const statusName = (status) => statuses.find((item) => item.value == status).label;

const checkEmpty = (value) => {
  if (value == '') {
    return 'N/A';
  }
  return value;
};

export default function Index({ page }) {
  const { state: policyState } = useManagerPolicyContext();

  return (
    <>
      <div className="inviteTabsCheckout_main">
        <div className="inviteTabsCheckoutMain_title">Policy</div>
      </div>
      <div className="invite-wrapper inviteTabsCheckout_control">
        {policyState.policy.id == '' && (
          <>
            <p className="font-14">
              Would you like to get the ball rolling on your Talent Insurance
              Program? Well, it all begins with creating a policy for your
              company. The LeggUP Team would be happy to help setup your policy.
              Click the button to contact us to get started!
              {' '}
            </p>
            <div className="text-right">
              <a
                href="https://meetings.hubspot.com/viktor-bullain"
                target="_blank"
                className="btn btn-green"
                rel="noreferrer"
              >
                Contact Sales
              </a>
            </div>
          </>
        )}
        {policyState.policy.id != '' && (
          <div className="font-14">
            <div className="well">
              <Row>
                <Col className="text-center" md={3}>
                  Policy number:
                  {' '}
                  {policyState.policy.attributes.number}
                </Col>
                <Col className="text-center" md={3}>
                  Original Effective Date:
                  {' '}
                  {checkEmpty(
                    policyState.policy.attributes
                      .original_effective_date_formatted,
                  )}
                </Col>
                <Col className="text-center" md={3}>
                  Renewal Date:
                  {' '}
                  {checkEmpty(
                    policyState.policy.attributes.renewal_date_formatted,
                  )}
                </Col>
                <Col className="text-center" md={3}>
                  Status:
                  {' '}
                  {statusName(policyState.policy.attributes.status)}
                </Col>
              </Row>
            </div>

            <table
              align="center"
              className="table table-borderless"
              style={{ width: '80%' }}
            >
              <tbody>
                <tr>
                  <td>
                    <b>Plan</b>
                  </td>
                  <td align="center">
                    <b>Sessions</b>
                  </td>
                  <td align="center">
                    <b>Covered Members</b>
                  </td>
                  {page == 'billing' && (
                    <>
                      <td align="center">
                        <b>PEPM</b>
                      </td>
                      <td align="center">
                        <b>Premium</b>
                      </td>
                    </>
                  )}
                  {page == 'checkout' && (
                    <td align="center">
                      <b>Available</b>
                    </td>
                  )}
                </tr>
                {policyState.policy.attributes.manager_statistics
                  .availability == null && (
                    <tr>
                      <td colSpan="4" align="center">
                        <i>No Active Plans</i>
                      </td>
                    </tr>
                  )}

                {policyState.policy.attributes.manager_statistics
                  .availability != null
                  && policyState.policy.attributes.manager_statistics.availability.map(
                    (item) => (
                      <tr>
                        <td>{item.title}</td>
                        <td align="center">
                          {item.sessions == 0 ? 'TA' : item.sessions}
                        </td>
                        <td align="center">{item.covered}</td>
                        {page == 'billing' && (
                          <>
                            <td align="center">
                              {moneyFormat(item.price_employee_month)}
                            </td>
                            <td align="center">
                              {moneyFormat(
                                item.billing == 'Monthly'
                                  ? item.monthly_total
                                  : item.annual_total,
                              )}
                              <span className="ml5">
                                {item.billing == 'Monthly'
                                  ? 'Per Month'
                                  : 'Per Year'}
                              </span>
                            </td>
                          </>
                        )}
                        {page == 'checkout' && (
                          <td align="center">{item.available}</td>
                        )}
                      </tr>
                    ),
                  )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
